//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MHeader from '../../Header/Header.vue';
import {
    getFinalNumberInfo
} from '../../../api';
export default {
    components: {
        MHeader
    },
    data() {
        return {
            item: "",
            show: false
        }
    },
    created() {
        this.$store.commit('showIsLoading');
        getFinalNumberInfo(`rob_id=${this.$route.params.rob_id}`).then(res => {
            if (res.data.error_code) {
                this.$router.go(-1);
                console.error(res);
                return;
            };
            this.item = res.data.data;
            console.log(this.item);
        });
    },
    filters: {
        code(val) {
            return val.replace(/[^0-9]/ig, "");
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/UserCenter/takeWine/formula.vue